import { render, staticRenderFns } from "./index.vue?vue&type=template&id=337d44e7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=337d44e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/nuxt/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337d44e7",
  null
  
)

export default component.exports